import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePageTeacher from '../pages/Teacher/HomePageTeacher';

import LoginPageTeacher from '../pages/Teacher/LoginPageTeacher';
import StudentListPage from '../pages/Teacher/StudentListPage';
import ProtectedRoute from '../routes/ProtectedRoute';

export default function TeacherRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="login" element={<LoginPageTeacher />} />
      
      {/* Protected Routes */}
      <Route path="/" element={<ProtectedRoute><HomePageTeacher /></ProtectedRoute>} />
 
      <Route path="ogrenciler" element={<ProtectedRoute><StudentListPage /></ProtectedRoute>} />
      
      {/* Catch all - redirect to main teacher page */}
      <Route path="*" element={<Navigate to="/teacher" replace />} />
    </Routes>
  );
}